var ToggleEvents;
(function (ToggleEvents) {
    ToggleEvents["ON"] = "on";
    ToggleEvents["OFF"] = "off";
    ToggleEvents["MIXED"] = "mixed";
    ToggleEvents["ENABLED"] = "enabled";
    ToggleEvents["DISABLED"] = "disabled";
    ToggleEvents["READONLY"] = "readonly";
})(ToggleEvents || (ToggleEvents = {}));
export default ToggleEvents;
